import axios from "axios";
import { getUrls } from "../data";

export const fetchCounts = async ({ token, activeModule }) => {
    try {
        const moduleUrls = getUrls()[activeModule];
        const response = await axios.get(moduleUrls["fetchUserCounts"], {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data?.data || [];

    } catch (error) {
        throw error;
    }
};

export const fetchUsers = async ({ token, payload, activeModule }) => {
    try {
        const moduleUrls = getUrls()[activeModule];
        const response = await axios.get(moduleUrls["fetchUsers"], {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: payload
        });
        return response.data?.data || [];
    } catch (error) {
        throw error;
    }
};

export const fetchOtherUsers = async ({ token, activeModule }) => {
    try {
        const moduleUrls = getUrls()[activeModule];
        const response = await axios.get(moduleUrls["fetchOtherUsers"], {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data?.data || [];
    } catch (error) {
        throw error;
    }
};

export const createNewUser = async ({ token, payload, activeModule }) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        await axios.post(
            moduleUrls["createNewUser"],
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    } catch (error) {
        throw error;
    }
};

export const createNewExistingUser = async ({ token, payload, activeModule }) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        await axios.post(
            moduleUrls["createNewExistingUser"],
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    } catch (error) {
        throw error;
    }
};

export const deleteUser = async ({ token, userId, activeModule }) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        await axios.post(
            moduleUrls["deleteUser"],
            { user_id: userId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    } catch (error) {
        throw error;
    }
};

export const deleteAndReplaceUser = async ({ token, payload, activeModule }) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        await axios.post(
            moduleUrls["deleteAndReplaceUser"],
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    } catch (error) {
        throw error;
    }
};

export const updateUserStatus = async ({
    token,
    userId,
    activeModule,
    payload,
}) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        await axios.post(
            `${moduleUrls["baseUrl"]}/user/${userId}/change_status`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    } catch (error) {
        throw error;
    }
};

export const resendInvitationEmail = async ({
    token,
    userId,
    activeModule,
    payload,
}) => {
    const moduleUrls = getUrls()[activeModule];

    try {
        await axios.post(
            `${moduleUrls["baseUrl"]}/user/${userId}/resend_set_password`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
    } catch (error) {
        throw error;
    }
};

export const downloadCSVTemplate = async ({ token, activeModule, onDownloadProgress, cancelToken }) => {
    const moduleUrls = getUrls()[activeModule];

    return axios.get(
        `${moduleUrls["baseUrl"]}/user/download_template`,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            },
            onDownloadProgress: onDownloadProgress,
            cancelToken: cancelToken
        }
    )
}

export const fetchAnalystAndAdminAnalysts = async ({ token, payload, activeModule }) => {
    const moduleUrls = getUrls()[activeModule];
    try {
        return await axios.post(
            moduleUrls["fetchAnalystAndAdminAnalysts"],
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    } catch (error) {
        throw error;
    }
};

export const uploadCSV = async ({
    token,
    activeModule,
    payload
}) => {
    const moduleUrls = getUrls()[activeModule];

    try {
        await axios.post(
            `${moduleUrls["uploadCSV"]}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
    } catch (error) {
        throw error;
    }
};